import React from 'react';

const Header = ({ logoUrl, poweredByUrl }) => {
  return (
    <div className="walkthrough-header">
      <a className="logo" href="/">
        <img src={logoUrl} alt="Statuspage logo" />
      </a>
      <span className="powered-by">
        <a
          href={poweredByUrl}
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          Powered by Statuspage
        </a>
      </span>
    </div>
  );
};

export default Header;
